import styled from "styled-components";
import TextareaInput from "../../../Field/TextareaInput/TextareaInput";

export const ConclusionTextareaField = styled(TextareaInput)`
  margin-top: 32px;
  & > textarea {
    margin-top: 0;
  }
`;
